<script lang="ts">
	import OrdersView from '$lib/components/Order/OrdersView.svelte';
	import type { PageData } from './$types';

	export let data: PageData;

	$: orders = data?.orders;
</script>

{#if orders}
	<div class="space-y-7 overflow-hidden">
		<OrdersView {orders} />
	</div>
{:else}
	<!-- TODO: Finish the "no orders yet" visual -->
	<div>No ORDERS yet</div>
{/if}
